import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment-timezone';

import styles from './FormDatePicker.scss';
import FormField from './FormField';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import 'assets/css/override-react-datepicker.css';

export default class FormDatePicker extends Component {
    static propTypes = {
        label: PropTypes.string,
        error: PropTypes.string,
        onChange: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.selected && props.selected.format('MM-DD-YYYY'),
        }
    }

    formatDateString = (value) => {
        const valueWithoutDashes = value.replace(/-/g, '');

        if (valueWithoutDashes.length <= 2) {
            return valueWithoutDashes;
        }

        const month = valueWithoutDashes.substring(0, 2);

        if (valueWithoutDashes.length > 2 && valueWithoutDashes.length < 5) {
            return `${month}-${valueWithoutDashes.substring(2)}`
        }

        return `${month}-${valueWithoutDashes.substring(2, 4)}-${valueWithoutDashes.substring(4)}`
    }

    handleChangeRaw = ({target: {value}}) => {
        const formattedValue = this.formatDateString(value);

        this.setState({value: formattedValue})
    }

    handleChange = (value) => {
        const {onChange} = this.props;
        this.setState({value: value && value.format('MM-DD-YYYY')}, () => {onChange(value);});
    }

    render() {
        const {label, error, className, ...datepickerProps} = this.props;
        const {value} = this.state;

        const inputClassName = classNames(styles.field, className, {
            [styles.highlightError]: Boolean(error)
        });
        const selected = value && value.length ? moment(value, 'MM-DD-YYYY') : null;

        return (
            <FormField label={label} error={error}>
                <DatePicker className={inputClassName}
                    {...datepickerProps}
                    onChange={this.handleChange}
                    selected={selected}
                    onChangeRaw={this.handleChangeRaw}
                    value={value}
                    error={error}
                />
            </FormField>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/controls/form/FormDatePicker.js